export default "__VITE_ASSET__B$c5Lx4p__"